import React, { Component } from "react";
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import Table from '@mui/material/Table';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import dayjs, { Dayjs } from 'dayjs';

const headCells = [


 
  
  { id: 'Title', numeric: false, label: 'Title' },  
  { id: 'Date', numeric: false, label: 'Date' }, 
{ id: 'hm_type', numeric: false, label: 'Type' },    
   { id: '',  label: '' },
  ]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
export default class Holiday extends Component {
	
    constructor(props) {
    super(props);
      var strdob=new Date();
	 var month="";
	

   	   var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}

      this.state = {redirect: false,hm_title:'', hmdate:'',hmdate1:'',
      Holidaydata:[],hmid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:10,rowsPaging:[],pagename:'',
	 
	  order:'desc' ,orderBy:'',names:'',searchcategory:'',
	          
      }
             this.updateDonenewParent = this.updateDonenewParent;
 
	   
	}

	updateDonenewParent = (text) => { this.apicall(this.state.page,this.state.rowsPerPage);  }





handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}



componentWillMount() {
 this.apicall(this.state.page,this.state.rowsPerPage);
}

handlesearchdate = (date) => {
	
	  var month="";
	  var date = new Date(date);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({
		 
		
	
hmdate:dayjs(date),
hmdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  } 

apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxholidaymanagemnet.php?action=getall&hm_title='+this.state.hm_title+'&hm_date='+this.state.hmdate1+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  Holidaydata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),rowsPaging:copy
			   

		    });
	  
	 
	 
     }
	 else{
		   this.setState({Holidaydata:[],totaldata:0});
	 }
 
    });
}



      HolidayDelete(hmid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r == true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','Delete')
	 formData.append('hm_id',hmid)
	 	  
				formData.append('userid',localStorage.getItem("AYUserid"))
	
	
	 axios.post(Serverurl+"ajaxholidaymanagemnet.php", formData, {
        }).then(res => {
    
              this.setState({  
      prevpage: -1,
    
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); });
  
    
            });
 }
      }


handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({ hmid:'', 
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  }; 
  
  handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
  

 handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


   HolidayBox(val){

        this.setState({ hmid: val });  
  
         setTimeout(() => this.refs.Addholidaybox.handleClickOpen(),500);

      }


render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  

<React.Fragment>

<div className="boxheading">				  
<h2> Holiday Management</h2>
</div>
<div className="clear"></div>
   <div className="searchmaster">



 
  <ul>
  
 <li>
 <p>Title</p>
 <p ><TextField

            variant="outlined"
            margin="normal"
            fullWidth value={this.state.hm_title}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Name"
            name="hm_title" onChange={this.myChangeHandler} className="txtbox"
		
          /></p></li>
		
			
	<li>
<p>Date</p>
     <p><LocalizationProvider dateAdapter={AdapterDayjs}>
     <DemoContainer components={['DatePicker']}>
    <DatePicker
     value= {dayjs(this.state.hmdate) }
     className="txtbox" 
	  name="hmdate"
      onChange={this.handlesearchdate} format="DD/MM/YYYY"
   />  </DemoContainer>
    </LocalizationProvider></p></li>
	
		
		<li><p>
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;
	  <Button variant="contained" onClick={()=>{this.HolidayBox(0)}} className="frmSecondarybtn" endIcon={<AddIcon />}>
        New
      </Button></p>
		</li> 
		
		
		
		
		</ul>
		
</div>		

<Addholidaybox ref="Addholidaybox" id={this.state.hmid}  updateDonenew={this.updateDonenewParent}/>


<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Holidaydata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Holidaydata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.hm_title}</TableCell>
<TableCell>{item.holidaydate}</TableCell><TableCell>{item.type}</TableCell>

<TableCell align="left">
<div className="actionbtns">
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.HolidayBox(item.hm_id)}} endIcon={<EditIcon />} >
Edit
</Button>&nbsp;&nbsp;


<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.HolidayDelete(item.hm_id)}}  endIcon={<DeleteIcon />}>
  Delete
</Button>

 


 </div>
 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
 <TablePagination  
        rowsPerPageOptions={[10,20,50, 100, 150,200]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />     
  </Paper>
    

 </React.Fragment> 

 
 
  );
}

}



export  class  Addholidaybox extends Component {

   constructor(props) {
      super(props)
	   var strdob=new Date();
	 var month="";
	

   	   var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}


      this.state = {
		  hm_date:Date.now(),hm_date1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),
		   open:false,hm_title:'',hm_id:0,hm_type:'',errormessage:'',erropen:false,btndisabled:false,
submitbtn:"Save"
	  }
      
  }
  
  
  



   
handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open,hm_type:'',  title:'',errormessage:'',erropen:false,
	  });
		
		this.HolidayGetData();


};
   myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val}); 
} 
	

 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }




 HolidayGetData() {
	
  if(this.props.id!==0)
  {
	  
	   axios.get(Serverurl+'ajaxholidaymanagemnet.php?action=getall&hm_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
      hm_id:resp.data[0].hm_id,
	  hm_title: resp.data[0].hm_title,
	  hm_date: resp.data[0].hm_date,
       
    
    });
	
  }
  
});
	  
  }else{
	 this.setState({  
	  hm_title:'',
	 
	 hm_type:'',
	 hm_id:0
	 
	  }); 
 }
  
    }



handleClose = (e) => {
	

if(this.state.hm_title==="")
{
	
	this.setState({errormessage:"Please Enter Title",erropen:true});
		
		 return false;
	
	
}

if(this.state.hm_date==="")
{
	
	this.setState({errormessage:"Please Select  Date",erropen:true});
		
		 return false;
	
	
}
if(this.state.hm_type==="")
{
	
	this.setState({errormessage:"Please Select  Type",erropen:true});
		
		 return false;
	
	
}

 this.setState({btndisabled:true,submitbtn:"Processing..."})

   var formData = new FormData();
  
  
   if(this.state.hm_id==0)
	  {
		  formData.append('hm_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('hm_id',this.state.hm_id)
		
      }
	  
	  
	  
	  
	 
        formData.append('action','insertupdate') 
		
		formData.append('hm_title',this.state.hm_title)
		formData.append('hm_date',this.state.hm_date1)
		formData.append('hm_type',this.state.hm_type)
		
		formData.append('userid',localStorage.getItem("AYUserid"))
		  
		axios.post(Serverurl+"ajaxholidaymanagemnet.php", formData, {
        }).then(res => {
    
	
	
	if(res.data === 0)
{ 
	 

		this.setState({open:false,btndisabled:false,
	 submitbtn:"Save",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}else{
		this.setState({open:false,btndisabled:false,
	 submitbtn:"Save",errormessage:"",erropen:false,open:false
		});
		this.props.updateDonenew();
	}
	
	
            
    
        });
  

};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

	
 handleholidayDate = (date) => {
	
	  var month="";
	  var date = new Date(date);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({
		 
		
	
hm_date:dayjs(date),
hm_date1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  } 


render (){

return(
<React.Fragment>


    <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title" className="dialoghead"> Manage Holiday</DialogTitle>
      <DialogContent>
	  


	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
     					  
	<p> <span className="validation">*</span> Title</p>
	
	<p><TextField name="hm_title" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.hm_title}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>	

<p><span className="validation">*</span>Date</p>
     <p><LocalizationProvider dateAdapter={AdapterDayjs}>
     <DemoContainer components={['DatePicker']}>
    <DatePicker
     value= {dayjs(this.state.hm_date) }
     
	  name="hm_date"
      onChange={this.handleholidayDate} format="DD/MM/YYYY"
   />  </DemoContainer>
    </LocalizationProvider></p>
<p> <span className="validation">*</span> Type</p>				  
						  <p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal" inputProps={{tabIndex: "3"}} className="txtbox"
          onChange={this.myChangeHandler}
          id="slottype"
		   value={this.state.hm_type}
		  name="hm_type"
		
        >
	
		<option value="">Select</option>
          <option value={1}>Before 12PM</option>
          <option value={2}>After 12PM</option>

 <option value={3}>Full Day</option>

        </Select>

		</FormControl>
		</p>
    <div className="actionbtns">
	   <div class="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.handleClickOpen}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handleClose}>
    {this.state.submitbtn}
</Button>
    </div>        
</div>

	
<div className="clear"></div>



	
	 
						    </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
} 
  